export default __webpack_public_path__ + "static/media/jm.593d0ceb.svg";